import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AlertModal } from 'shared';
import { minersSelector } from 'store/slices/miners-slice';
import { productsSelector } from 'store/slices/products-slice';
import { userDataSelector } from 'store/slices/user-slice';

export const NoConnectedMinersModal = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const user = useSelector(userDataSelector);
  const miners = useSelector(minersSelector);
  const products = useSelector(productsSelector);

  useEffect(() => {
    if (!user || !products.length || miners.allMiners?.length) return;

    setIsOpen(true);
  }, [user, products, miners]);

  const title = 'You have no Miner yet.';

  const content = (
    <>
      <Typography variant='body1' gutterBottom>
        Start mining within minutes. Whether you&apos;re new or experienced, getting started is quick and easy.
      </Typography>
      <Typography variant='body2' gutterBottom>
        Have questions? Our team is here to help every step of the way.
      </Typography>
    </>
  );

  const handleNavigateShop = () => {
    navigate('/shop');
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <AlertModal
          title={title}
          content={content}
          primaryButtonText='Discover Miners'
          primaryButtonHandler={handleNavigateShop}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
